export const environment = {
  production: false,
  // Proxied to the backend by proxy.conf.json during `ng serve`.
  apiUrl: '/api/v1',
} as const;
